import { IOrderDetail } from "../../apis/useGetOrderDetail/types";
import { ICheckoutResponse } from "../../apis/useSubmitCheckout/types";
import { createContextReducer } from "../../common/helpers/createContextReducer";
import { Nullable } from "../../common/types/types";
import { initialState } from "./constants";
import { IPaymentState, OrderStatus } from "./types";

const PaymentContextReducer = {
	SET_PAYMENT_REFERENCE: (state: IPaymentState, paymentReference: Nullable<string>) => {
		state.paymentReference = paymentReference;
	},
	SET_PAYMENT_DATA: (state: IPaymentState, response: ICheckoutResponse) => {
		state.paymentData = response;
		state.paymentReference = response?.payment_reference;
	},
	SET_ORDER_DETAIL: (state: IPaymentState, orderDetail: Nullable<IOrderDetail>) => {
		state.orderDetail = orderDetail;
	},
	SET_ORDER_STATUS: (state: IPaymentState, status: OrderStatus) => {
		state.orderStatus = status;
	},
	CLEAR_PAYMENT_DATA: (state: IPaymentState) => {
		state.paymentReference = null;
		state.paymentData = null;
		state.orderDetail = null;
		state.orderStatus = "idle";
	},
};

const {
	AppProvider: PaymentProvider,
	useContextActions: usePaymentActions,
	useContextPartial: usePaymentContext,
} = createContextReducer(initialState, PaymentContextReducer);

export { PaymentProvider, usePaymentActions, usePaymentContext };
